module.exports = __webpack_public_path__ + "static/media/drag-icon-threshold.aac8f7db.svg";